
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/agencies/[...slug]",
      function () {
        return require("private-next-pages/agencies/[...slug].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/agencies/[...slug]"])
      });
    }
  